<template>
    <div>
        <b-modal id="upload-registry-file" title="Dosya Yükle" no-close-on-esc no-close-on-backdrop>
            <employee-registry-file-document-upload v-model="file"></employee-registry-file-document-upload>
            <template #modal-footer><v-executer :loading="loading" text="Yükle" :action="uploadFile"></v-executer></template>
        </b-modal>

        <v-file-viewer ref="fileViewer"></v-file-viewer>

        <b-modal size="lg" id="history" title="İşlem Geçmişi" scrollable hide-footer no-close-on-esc no-close-on-backdrop>
            <employee-registry-file-document-history v-model="historyData"></employee-registry-file-document-history>
        </b-modal>

        <b-modal size="sm" id="errors" body-class="p-50" title="Dosya Gereksinimleri" scrollable hide-footer no-close-on-esc no-close-on-backdrop>
            <employee-registry-file-document-errors v-model="fileErrors"></employee-registry-file-document-errors>
        </b-modal>

        <v-table    ref="table"
                    with-items
                    :items="files"
                    name="employee-registry-file"
                    :fields="fields"
                    :settings="false"
                    buttons-in-dropdown
                    button-alignment="text-left"
                    :buttons="buttons"></v-table>

        <employee-external-registry-files :id="id" :code="code"/>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import Additional from '@/utilities/additional'
import EmployeeRegistryFileDocumentUpload from './EmployeeRegistryFileDocumentUpload.vue'
import EmployeeRegistryFileDocumentHistory from './EmployeeRegistryFileDocumentHistory.vue'
import EmployeeRegistryFileDocumentErrors from './EmployeeRegistryFileDocumentErrors.vue'
import VFileViewer from '@/components/VFileViewer.vue'
import EmployeeExternalRegistryFiles from './EmployeeExternalRegistryFiles.vue'
import print from 'print-js';


export default {
    components:{
        EmployeeRegistryFileDocumentUpload,
        EmployeeRegistryFileDocumentHistory,
        EmployeeRegistryFileDocumentErrors,
        EmployeeExternalRegistryFiles,
        VFileViewer,
    },  
    props:{
        id:[String,Number],
        code:[String,null]
    },
    data(){
        return{
            files:[],
            fields:[
                { key:"InventoryCode", name:"Envanter Kodu" },
                { key:"FileName",thClass:'w-100', name:"Belge" },
                { key:"DocumentTypeName", name:"Belge Türü" },
                { key:"SignatureType", name:"İmza Türü",tdClass:'text-nowrap'},
                { key:"Errors",name:"Dosya Gereksinimleri",component:true,componentOptions:{name:"employee-registry-error/EmployeeRegistryError"}},
                { key:"Status",name:"Durum",component:true,componentOptions:{name:"employee-registry-file/EmployeeRegistryFile"}},
            ],
            buttons:[
                { text:"Oluştur",key:"generate",icon:"PlayIcon", variant:"primary", action:this.generate,condition:(item)=> (this.$safe(item,'Errors') || []).length == 0 },
                { text:"İndir",key:"download",icon:"DownloadIcon", variant:"warning", action:this.download,condition:(item) => item.File != null },
                { text:"Yazdır",key:"print",icon:"PrinterIcon", variant:"primary", action:this.print,condition:(item) => item.File != null },
                { text:"Görüntüle",key:"view",icon:"EyeIcon", variant:"success", action:this.view,condition:(item) => item.File != null },
                { text:"Yükle",key:"upload",icon:"UploadIcon", variant:"info", action:this.uploadFileShow,condition:(item) => item.File != null },
                { text:"İşlem Geçmişi",key:"history",icon:"ClockIcon", variant:"secondary", action:this.history,condition:(item) => item.File != null },
                { text:"Dosya Gereksinimleri", key:"errors", icon:"AlertTriangleIcon", variant:"danger",action:this.showErrors,condition:(item)=> (this.$safe(item,'Errors') || []).length != 0  }
            ],
            loading:false,
            historyData:[],
            fileErrors:[],
            file:{
                SystemCode:null,
                RegistryDocumentId:null,
                EmployeeId:null,
                File:null,
            },
            pdf:{
                url:null
            }
        }
    },
    mounted(){
        if(this.id && this.code){
            this.getRegistryDocuments()
        }
    },
    watch:{
        id(oldVal,newVal){
            if(oldVal != newVal) this.getRegistryDocuments()
        },
        code(oldVal,newVal){
            if(oldVal != newVal) this.getRegistryDocuments()
        }
    },
    methods:{
        clearForm(){
            this.file.SystemCode = null
            this.file.File = null
            this.file.EmployeeId = null
            this.historyData = []
            this.fileErrors = []
            this.pdf.url = null
        },  
        getRegistryDocuments(){
            this.$refs.table.setLoading(true)
            EmployeeOperationsApi.Employee.RegistryFile.List(this.code,this.id).then(res=>{
                this.files = res.data
                this.$refs.table.setLoading(false)
            })
        },
        uploadFileShow(item){
            this.clearForm()
            this.file.SystemCode = item.FileName
            this.file.RegistryDocumentId = item.RegistryDocumentId
            this.$showModal('upload-registry-file')
        },
        async uploadFile(){
            this.loading = true
            this.file.EmployeeId = this.id
            let formData = await Additional.ToFormData(this.file,['File'])
            EmployeeOperationsApi.Employee.RegistryFile.Upload(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.getRegistryDocuments()
                    this.$hideModal('upload-registry-file')
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        download(item){
            this.$refs.table.rowLoading(true)
            Additional.GetBlobFile(item.File.FilePath).then(blob=>{
                Additional.DownloadFile(blob.data,item.File.FileName + item.File.FileExtension)
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
            })
        },
        generate(item){
            this.$refs.table.rowLoading(true)
            console.log(item)
            EmployeeOperationsApi.Employee.RegistryFile.Generate(this.id,item.Index,item.Type).then(res=>{
                this.$result(res)
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.getRegistryDocuments()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        },
        history(item){
            this.clearForm()
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.Employee.RegistryFile.GetProcess(item.Type, this.id,item.FileName).then(res=>{
                this.historyData = res.data.Data
                this.$showModal('history')
                this.$refs.table.rowLoading(false)
            })
        },
        showErrors(item){
            this.fileErrors = item.Errors
            this.$showModal('errors')
        },
        view(item){
            this.$refs.fileViewer.view(item.File.FilePath)
        },
        print(item){
            this.clearForm()
            this.pdf.url = item.File.FilePath
            const w = window.open(item.File.FilePath,'name','height=1100,width=794')
            w.onload = () => { w.print() }
        },
    }
}
</script>

<style>
.a4{
    width: 210mm;
    height: 297mm;
}
</style>